module.exports = __webpack_public_path__ + "media/images/ico-video-no-7b543ee8.svg";